import { AxiosResponse } from 'axios';
import { z } from 'zod';

type Contract<T> = z.ZodType<T> | ((value: unknown) => T | Error);
type Options<T, E> = {
    mapResponse?: (response: AxiosResponse) => unknown;
    In: Contract<T>;
    Out: Contract<E>;
    handler: (params: T) => Promise<AxiosResponse>;
};

export function strictQuery<T, E>(options: Options<T, E>): (params: T) => Promise<E>;
export function strictQuery<T, E>(options: Options<T, E>): (params: T) => Promise<E> {
    const mapResponse = options.mapResponse || ((response: AxiosResponse) => response.data);
    type mapResponseReturnType = ReturnType<typeof mapResponse>;
    const responseParser = (response: mapResponseReturnType) => {
        if ('response' in options && options.Out instanceof z.ZodObject) {
            return options.Out.parse(response);
        }
        return response;
    };
    const requestParser = (params: unknown) => {
        if ('request' in options && options.In instanceof z.ZodObject) {
            return options.In.parse(params);
        }
        return params;
    };
    return (params: T) => options.handler(requestParser(params)).then(mapResponse).then(responseParser);
}
